import { ZEPTO_DOMAIN } from '../../constants/global';
import {
  GetCookieInterface,
  SetCookieInterface,
  RemoveCookieInterface,
} from './types';

abstract class BaseCookieClient {
  public static getCookie: GetCookieInterface;
  public static setCookie: SetCookieInterface;
  public static removeCookie: RemoveCookieInterface;
}

class CookieManager extends BaseCookieClient {
  public static getCookie: GetCookieInterface = (cookieName) => {
    if (
      typeof window !== 'undefined' &&
      typeof window.document !== 'undefined'
    ) {
      const cookies = Object.fromEntries(
        document.cookie
          .split('; ')
          .map((v) => v.split(/=(.*)/s).map(decodeURIComponent))
      );
      return cookies[cookieName];
    }
    return undefined;
  };

  public static setCookie: SetCookieInterface = ({
    cookieName,
    value,
    expiryDays,
    hostOnly = false,
  }) => {
    if (
      typeof window !== 'undefined' &&
      typeof window.document !== 'undefined'
    ) {
      let expires = '';
      let domain = `; domain=${
        process.env?.['REACT_APP_NODE_ENV'] !== 'development'
          ? ZEPTO_DOMAIN
          : ''
      }`;
      if (expiryDays) {
        const date = new Date();
        date.setTime(date.getTime() + expiryDays * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      }
      if (hostOnly && process.env?.['REACT_APP_NODE_ENV'] !== 'development') {
        domain = `; domain=.${ZEPTO_DOMAIN}`;
      }
      document.cookie = `${cookieName}=${
        value || ''
      }${expires}${domain}; path=/`;
    }
  };

  public static removeCookie: RemoveCookieInterface = (cookieName) => {
    this.setCookie({ cookieName });
  };
}

export default CookieManager;
